exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "code .token.operator {\n  background: none;\n}\n\n:not(pre) > code[class*='language-'],\npre[class*='language-'] {\n  background: var(--primary-background);\n}\n\n* {\n  text-shadow: none !important;\n}\n", "", {"version":3,"sources":["/app/client/src/components/layouts/prism.css"],"names":[],"mappings":"AAAA;EACE,iBAAgB;CAClB;;AAEA;;EAEE,sCAAqC;CACvC;;AAEA;EACE,6BAA4B;CAC9B","file":"prism.css","sourcesContent":["code .token.operator {\n  background: none;\n}\n\n:not(pre) > code[class*='language-'],\npre[class*='language-'] {\n  background: var(--primary-background);\n}\n\n* {\n  text-shadow: none !important;\n}\n"],"sourceRoot":""}]);

// exports
